import { io } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "https://api.ticketdovaqueiro.com";

export function conectarSocketPainel() {
  return io(SOCKET_URL, {
    path: "/socket.io",
    transports: ["polling", "websocket"], // ✅ deixa fallback
    withCredentials: false,
    reconnection: true,
    reconnectionAttempts: 50,
    reconnectionDelay: 500,
    timeout: 20000,
  });
}
